module.exports = __webpack_public_path__ + "img/interfaceNormalMap.2d83a553.png";